import { DesiredSettingValueKind } from '@crossnokaye/typescript-sdk/models/components';

import { RefValueKind } from '@repo/sdk/models/components';

import {
  isBooleanLike,
  resolveBooleanValue,
} from '@/helpers/unit-formatter/transformers/coerce-boolean-like';

export const castSettingsValue = (value: any, kind: RefValueKind | undefined) => {
  switch (kind) {
    case RefValueKind.Number:
      return Number(value);
    case RefValueKind.Boolean:
      if (typeof value === 'boolean') return value;
      // A boolean field submits the label it shows, and a setting picks its own
      // vocabulary — ON / OPEN as much as TRUE — so read every label the catalog
      // knows rather than the single word `true`. A string the catalog cannot read
      // is not a guess to take on a write to equipment: it stays false, as it was.
      if (typeof value === 'string' && !isBooleanLike(value)) return false;
      return resolveBooleanValue(value);
    case RefValueKind.Enum:
      return String(value);
    case RefValueKind.String:
      return String(value);
    case RefValueKind.Schedule:
    case RefValueKind.Sequence:
    default:
      return value;
  }
};

export const getDesiredSettingValueKind = (
  valueKind: RefValueKind | undefined
): DesiredSettingValueKind => {
  switch (valueKind) {
    case RefValueKind.Boolean:
      return DesiredSettingValueKind.Bool;
    case RefValueKind.Number:
      return DesiredSettingValueKind.Number;
    case RefValueKind.Enum:
      return DesiredSettingValueKind.Enum;
    case RefValueKind.Schedule:
      return DesiredSettingValueKind.Schedule;
    case RefValueKind.Sequence:
      return DesiredSettingValueKind.Sequence;
    case RefValueKind.String:
    default:
      return DesiredSettingValueKind.Enum;
  }
};
